import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ToastService } from './toast.service';
import { ToastMessage, TOAST_ICONS, TOAST_CLASSES } from './toast.model';

/**
 * Componente Toast para mostrar notificaciones usando Bootstrap 5
 */
@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts: ToastMessage[] = [];
  private destroy$ = new Subject<void>();

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    // Suscribirse a nuevos toasts
    this.toastService.toast$.pipe(takeUntil(this.destroy$)).subscribe((toast) => {
      this.addToast(toast);
    });

    // Suscribirse a la eliminación de toasts
    this.toastService.removeToast$.pipe(takeUntil(this.destroy$)).subscribe((id) => {
      this.removeToast(id);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Agrega un nuevo toast y programa su eliminación automática
   * @param toast Toast a agregar
   */
  private addToast(toast: ToastMessage): void {
    this.toasts.push(toast);

    if (toast.autohide) {
      setTimeout(() => {
        this.removeToast(toast.id);
      }, toast.delay || 5000);
    }
  }

  /**
   * Remueve un toast de la lista
   * @param id ID del toast a remover
   */
  removeToast(id: string): void {
    this.toasts = this.toasts.filter((t) => t.id !== id);
  }

  /**
   * Obtiene el icono correspondiente al tipo de toast
   * @param type Tipo de toast
   */
  getIcon(type: string): string {
    return TOAST_ICONS[type as keyof typeof TOAST_ICONS] || TOAST_ICONS.info;
  }

  /**
   * Obtiene las clases CSS correspondientes al tipo de toast
   * @param type Tipo de toast
   */
  getToastClass(type: string): string {
    return TOAST_CLASSES[type as keyof typeof TOAST_CLASSES] || TOAST_CLASSES.info;
  }

  /**
   * Determina si el botón de cierre debe ser blanco
   * @param type Tipo de toast
   */
  isWhiteClose(type: string): boolean {
    return type === 'success' || type === 'error' || type === 'info';
  }
}
